// SPDX-License-Identifier: AGPL-3.0-or-later

import type {GuildBan} from '@app/features/guild/commands/GuildCommands';
import {BanDetailsModal} from '@app/features/moderation/components/modals/BanDetailsModal';
import {RevokeBanIcon, ViewDetailsIcon} from '@app/features/ui/action_menu/ContextMenuIcons';
import {MenuGroup} from '@app/features/ui/action_menu/MenuGroup';
import {MenuItem} from '@app/features/ui/action_menu/MenuItem';
import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import {modal} from '@app/features/ui/commands/ModalCommands';
import {Trans} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';

interface BannedUserContextMenuProps {
	ban: GuildBan;
	onClose: () => void;
	onRevoke: () => void;
}
export const BannedUserContextMenu: React.FC<BannedUserContextMenuProps> = observer(({ban, onClose, onRevoke}) => {
	const handleViewDetails = () => {
		onClose();
		ModalCommands.push(modal(() => <BanDetailsModal ban={ban} onRevoke={onRevoke} />));
	};
	const handleRevokeBan = () => {
		onClose();
		onRevoke();
	};
	return (
		<>
			<MenuGroup>
				<MenuItem icon={<ViewDetailsIcon />} onClick={handleViewDetails}>
					<Trans>View Details</Trans>
				</MenuItem>
			</MenuGroup>
			<MenuGroup>
				<MenuItem icon={<RevokeBanIcon />} danger onClick={handleRevokeBan}>
					<Trans>Revoke Ban</Trans>
				</MenuItem>
			</MenuGroup>
		</>
	);
});
